import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { Subject } from 'rxjs/internal/Subject';
import { CorreiosAuth, CorreiosServices } from 'src/app/services/correios.services';
import { DialogService } from 'src/app/services/dialog.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { UserConfigServices } from 'src/app/services/user-config.services';
import { PromptField, PromptSaveDialogComponentMultiple } from 'src/app/system-utils/prompt-save-dialog-multiple/prompt-save-dialog-multiple.component';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import xmlTojson from 'src/app/script/xmlTojson';
//import xml2js from 'xml2js'
import { StringUtils } from 'src/app/system-utils/utils/StringUtils';
import { ConnectionPositionPair } from '@angular/cdk/overlay';

export interface TrackingData{
    id:number;
    tipo:string;
    status:string;
    data:string;
    hora:string;
    descricao:string;
    codigo:string;
    cidade:string;
    uf:string;
}

@Component({
    selector: 'cep-buscaobjeto',
    templateUrl: './cep-buscaobjeto.component.html',
    styleUrls: ['./cep-buscaobjeto.component.scss'],
    standalone: false
})



export class CepBuscaobjetoComponent implements OnInit {

  info: { title: string; fields:PromptField[]};
  mensagemObj:TrackingData[] = [];

  positionPairs: ConnectionPositionPair[] = [
    {
      offsetX: 1,
      offsetY: 1,
      originX: 'start',
      originY: 'bottom',
      overlayX: 'start',
      overlayY: 'bottom',
      panelClass: null,
    },
  ];

  constructor(private fb:UntypedFormBuilder, 
              private cs:CorreiosServices, 
              private snackService:SnackbarService,
              private dialog:DialogService,
              private ucs:UserConfigServices,
              private uid:UserAuthenticationServices ) { }

  @Input() codecompany:number;
  @Input() codecontract:number;
  @Input() servico:Object;
  @Input() correiosAuth:CorreiosAuth;
  formValidation:UntypedFormGroup;
  @Input() eventUserConfig: Observable<object>;
  userConfig = {};
  private eventsSubscription: Subscription;

  ngOnInit(): void {
      this.formValidation = this.fb.group({
        tracking: new UntypedFormControl(null,[Validators.required]),
    });

    // this.eventsSubscription = this.eventUserConfig.subscribe(value=>{
    //   this.userConfig = value;
    // });
    
  }

  ngOnDestroy(){
      //this.eventsSubscription.unsubscribe();
  }

  
  clear(campo:string){
    this.formValidation.get(campo).setValue(null);
  }

  clickAction(item){
    
    if ( !item['hover'] ){
        item['hover'] = true;
    }else{
        item['hover'] = false;
    }

    this.mensagemObj.forEach(data=>{
        if ( data.id != item.id ){
            data['hover'] = false;
        }
    })
  }

  consultar(){

    if ( !this.formValidation.valid ){
      this.formValidation.markAllAsTouched();
      return;
    } 

    this.mensagemObj = [];

    this.cs.getTracking(
              this.codecompany, 
              this.codecontract, 
              this.formValidation.get('tracking').value,
              this.correiosAuth).then(data=>{
                // const p: xml2js.Parser = new xml2js.Parser();
                // p.parseString(data, (err, result) => {
                //   if (err) {
                //     throw err;
                //   }
                  
                //   let json:string  = JSON.stringify(result, null, 4); 
                //   json = json.replace(/soapenv:/g,'');
                //   json = json.replace(/ns2:/g,'');
                //   let JSONObject = JSON.parse(json);
                  
                //   let servico:any[] = ObjectUtil.FindObject(JSONObject,'$.Envelope.Body[0].buscaEventosListaResponse[0].return[0].objeto[0].evento');
                //   let detail:any[] = servico[0];
                //   let i = 1;
                //   for ( var d of detail ){
                //       let evento:TrackingData = {
                //           id:i,
                //           tipo:getData(d,'tipo'),
                //           status:getData(d,'status'),
                //           data:getData(d,'data'),
                //           hora:getData(d,'hora'),
                //           descricao:getData(d,'descricao'),
                //           codigo:getData(d,'codigo'),
                //           cidade:getData(d,'cidade'),
                //           uf:getData(d,'uf')
                //       }
                //       this.mensagemObj.push(evento);
                //       i++;
                //   };

                //});


              })
  }
}
function getData(servico: any, path:string) {
  try{
    return servico[path][0];
  }catch(Exception){
    return null;
  }
}


